import { takeLatest, put, call } from 'redux-saga/effects';

import { listTransferenciaEstoque } from '../service';
import {
  TABLE_TRANSFERENCIA_ESTOQUE,
  TABLE_TRANSFERENCIA_ESTOQUE_PENDING,
  TABLE_TRANSFERENCIA_ESTOQUE_SUCCESS,
  TABLE_TRANSFERENCIA_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaListTransferenciaEstoque(action) {
  yield put({ type: TABLE_TRANSFERENCIA_ESTOQUE_PENDING })

  try {
    const table = yield call(listTransferenciaEstoque, action.args)
    yield put({ type: TABLE_TRANSFERENCIA_ESTOQUE_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_TRANSFERENCIA_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListTransferenciaEstoque() {
  yield takeLatest(TABLE_TRANSFERENCIA_ESTOQUE, sagaListTransferenciaEstoque)
}